@let formGroupLabel = formLabel();
@if(formGroupLabel){
<h2 class="ui-form-label">{{ formGroupLabel | localization }}</h2>
}

@let formGroup = form();
@if(formGroup){
<form
  class="ui-form"
  nz-form
  nzLayout="vertical"
  [formGroup]="formGroup"
  [style]="groupDirection()"
  [style.gap]="groupItemGap()"
>
  @for (field of groupFields(); track field[0]) {
  <ng-container [ngSwitch]="field[1].type">
    <ng-container *ngSwitchCase="FormFieldType.GROUP">
      <ui-form
        [parentWidth]="hostWidth()"
        [form]="formGroup | getFormControl : (field[1]?.forWrapping ? '' : field[0])"
        [fieldName]="field[0]"
        [config]="field[1]"
        (linkClicked)="linkClicked.emit($event)"
      ></ui-form>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.INPUT">
      <ui-form-input
        [formControl]="formGroup | getFormControl : field[0]"
        [fieldName]="field[0]"
        [config]="field[1]"
        (enterPressed)="onEnterPressed()"
      ></ui-form-input>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.PASSWORD">
      <ui-form-password
        [formControl]="formGroup | getFormControl : field[0]"
        [fieldName]="field[0]"
        [config]="field[1]"
        (enterPressed)="onEnterPressed()"
      ></ui-form-password>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.TEXTAREA">
      <ui-form-textarea
        [formControl]="formGroup | getFormControl : field[0]"
        [fieldName]="field[0]"
        [config]="field[1]"
      ></ui-form-textarea>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.SELECT">
      <ui-form-select
        [formControl]="formGroup | getFormControl : field[0]"
        [fieldName]="field[0]"
        [config]="field[1]"
      ></ui-form-select>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.DATE">
      <ui-form-date
        [formControl]="formGroup | getFormControl : field[0]"
        [fieldName]="field[0]"
        [config]="field[1]"
      ></ui-form-date>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.TIME">
      <ui-form-time
        [formControl]="formGroup | getFormControl : field[0]"
        [fieldName]="field[0]"
        [config]="field[1]"
      ></ui-form-time>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.TIMEPICKER">
      <ui-form-timepicker
        [formControl]="formGroup | getFormControl : field[0]"
        [fieldName]="field[0]"
        [config]="field[1]"
      ></ui-form-timepicker>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.CHECKBOX">
      <ui-form-checkbox
        [formControl]="formGroup | getFormControl : field[0]"
        [fieldName]="field[0]"
        [config]="field[1]"
        (linkClicked)="linkClicked.emit($event)"
      ></ui-form-checkbox>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.FILE">
      <ui-form-file
        [formControl]="formGroup | getFormControl : field[0]"
        [fieldName]="field[0]"
        [config]="field[1]"
      ></ui-form-file>
    </ng-container>
    <ng-container *ngSwitchCase="FormFieldType.TEXT_EDITOR">
      <ui-wysiwyg [content]="formGroup | getFormControl : field[0]" [label]="field[1].label | localization"></ui-wysiwyg>
    </ng-container>
  </ng-container>
  }
</form>
}
